import React, { useEffect, useState } from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import './PhoneField.scss';
const phoneUtil = require('google-libphonenumber').PhoneNumberUtil.getInstance();
import { isValidPhoneNumber } from 'react-phone-number-input';
import { CountryList } from '../../../Utils/CountryList';
import { useDispatch } from 'react-redux';
import { validNumber } from '../../../Action/action';

function PhoneField(props) {
  const dispatch = useDispatch();
  const [userCountry, SetCountry] = useState('');
  const [valid, setValid] = useState(null);

  const getGeoInfo = () => {
    fetch('https://ipapi.co/json/')
      .then((response) => response.json())
      .then((data) => SetCountry(data && data.country_code.toLocaleLowerCase()))
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getGeoInfo();
  }, []);

  useEffect(() => {
    dispatch(validNumber(valid));
  }, [valid]);

  const allowedCountries = CountryList.map((item) => item.code.toLocaleLowerCase());
  return (
    <div className="Phone_input">
      <PhoneInput
        isValid={(value, country) => {
          const countryLength = country && country.countryCode.length;
          if (
            value &&
            value.length >= countryLength &&
            value.length - countryLength > 1
          ) {
            setValid(true);
            return true;
          }
          if (value.length - countryLength === 0) {
            setValid(true);
            return true;
          } else {
            setValid(false);
            return false;
          }
          // const phoneLength =
          //   country &&
          //   country.format
          //     .substring(country.countryCode.length + 1, country.format.length)
          //     .match(/\./g).length;

          // if (value && value.length >= countryLength + 1) {
          //   if (value.length - countryLength === phoneLength) {
          //     setValid(true);
          //     return true;
          //   } else {
          //     setValid(false);
          //     return false;
          //   }
          // } else {
          //   if (value && value.length >= countryLength + 1) {
          //     setValid(true);
          //   }
          // }
          return true;
        }}
        inputProps={{
          name: props.name,
        }}
        helperText="Invalid number"
        country={props.country ? userCountry : ''}
        onlyCountries={allowedCountries}
        countryCodeEditable={false}
        dropdownStyle={{ textAlign: 'left' }}
        placeholder="Enter phone number"
        value={props.value}
        onChange={props.setValue}
      />
    </div>
  );
}

export default PhoneField;
